import md5 from "crypto-js/md5";
import { useDispatch, useSelector } from "react-redux";
import { createNewOrder } from "../../../redux/features/order/orderServices";
import styles from "./index.module.css";
import { useState } from "react";

const PaymentForm = ({ course_id }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.userDetails.details);
  const order = useSelector((state) => state.order.orderDetails.orderResponse);

  const [loading, setLoading] = useState(false);

  const checkoutOrder = async (event) => {
    event.preventDefault();
    const data = {
      course_id: course_id,
    };
    try {
      setLoading(true);
      const response = await dispatch(createNewOrder(data)).unwrap();
      if (response.success === true) {
        const form = document.getElementById("payhereForm");
        form.submit();        
      setLoading(false);
      } else {
        console.error("Error creating order:", response.message);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error during order creation:", error);
      setLoading(false);
    }
  };

  return (
    <form
      id="payhereForm"
      method="post"
      action="https://www.payhere.lk/pay/checkout"
    >
      <input type="hidden" name="merchant_id" value="230942" />
      <input
        type="hidden"
        name="return_url"
        value={`https://www.studyhub.lk`}
      />
      <input
        type="hidden"
        name="cancel_url"
        value={`https://www.studyhub.lk`}
      />
      <input
        type="hidden"
        name="notify_url"
        value={`https://api-v1.studyhub.lk/api/v1/orders/payhere-webhook/${order?.id}`}
      />
      <input type="hidden" name="order_id" value={order?.id} />
      <input type="hidden" name="items" value="Course" />
      <input type="hidden" name="currency" value="LKR" />
      <input
        type="hidden"
        name="amount"
        value={parseFloat(order?.amount)
          .toLocaleString("en-US", { minimumFractionDigits: 2 })
          .replaceAll(",", "")}
      />
      <input type="hidden" name="first_name" value={user.full_name} />
      <input type="hidden" name="last_name" value="Studyub" />
      <input type="hidden" name="email" value={user.email} />
      <input type="hidden" name="phone" value={user.phone_number} />
      <input type="hidden" name="address" value="No.1, Galle Road" />
      <input type="hidden" name="city" value="Colombo" />
      <input type="hidden" name="country" value="Sri Lanka" />
      <input
        type="hidden"
        name="hash"
        value={md5(
          "230942" +
          `${order?.id}` +
          parseFloat(order?.amount)
            .toLocaleString("en-US", { minimumFractionDigits: 2 })
            .replaceAll(",", "") +
          "LKR" +
          md5("Mjc5MDMyMzA5MDQyNjA5NDg1OTkxNjU3NzkyNzY5MzI3NzMzMDU1Mw==")
            .toString()
            .toUpperCase()
        )
          .toString()
          .toUpperCase()}
      />
      <input
        type="button"
        value={loading? `Checking out` : `Check out`}
        className={`primary-btn ${styles.purchaseBtn}`}
        onClick={checkoutOrder}
        disabled={loading}
      />
      {/* <input
        type="submit"
        value="Purchase"
        className={`primary-btn ${styles.purchaseBtn}`}
      /> */}
    </form>
  );
};

export default PaymentForm;
